import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import ProjectHeader from "./ProjectHeader";
import ProjectImage from "./ProjectImage";
import bigImage from "../../../assets/images/caregiver-desktop-header.jpg";
import "../../../styles/pages/projects/Project.css";
import mobile1 from "../../../assets/images/caregiver-mobile-1.png";
import mobile2 from "../../../assets/images/caregiver-mobile-2.png";
import gif from "../../../assets/images/caregiver-gif.gif";
import ProjectConclusion from "./ProjectConclusion";
import Footer from "../../footer/Footer";
import onScrollHandler from "../../../utilities/onScrollHandler";
import NextPrompt from "../../nextprompt/NextPrompt";

export default class JaelsCreations extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="Caregiver page-wrapper">
        <NavMenu />
        <ProjectHeader
          title="CARE GIVER TO THE RESCUE"
          year="2018"
          contributions={[
            "Web Design",
            "Website Development",
            "Copywriting",
            "Photography"
          ]}
          projectLink={"#"}
          description={
            <div>
              Savina Nelson is the Caregiver to the Rescue. She provides in-home
              assistance to people with dementia, alzheimers, and other medical
              disabilities.
              <br />
              <br />
              Her old website wasn’t cutting it - She needed something that
              would properly portray who she is, what she does, and why she does
              it.
            </div>
          }
        />
        <ProjectImage
          projectName={"Caregiver"}
          layout={"big-image"}
          image={bigImage}
          backgroundColor={"#B58AFF"}
        />
        <div className="gutters">
          <div className="project-text g-sub-text on-scroll-anim">
            The most difficult aspect of this project was the copy. Hiring a
            Caregiver is a major decision for anybody - The site needed to come
            across as trustworthy, experienced, and professional.
            <br />
            <br />
            We tried to make the website as accessible as possible with clear,
            concise text, large images, and a straightforward layout.
          </div>
        </div>
        <ProjectImage
          projectName={"Jaels Creations"}
          layout={"gif-showcase"}
          mobileImages={[mobile1, mobile2]}
          gif={gif}
          backgroundColor={"#B58AFF"}
        />
        <ProjectConclusion
          text={
            <div>
              Caregiver to the Rescue was a unique project that taught us the
              importance of the tone and clarity of a website’s copy, as well as
              the accessability of the site as a whole.
              <br />
              <br />
              We’re glad we were able to get Savina a quality website to help
              her business grow.
            </div>
          }
        />

        <NextPrompt />
        <Footer page={"jaels"} />
      </div>
    );
  }
}
